import React from 'react';
import { ActionButton } from '@klp/design/Action';
import { useKostnadsKalkyleContext } from '../context/KostnadsKalkyleProvider';
import type { Theme } from '@material-ui/core';
import { Box, TextField } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { NumericFormat } from 'react-number-format';

const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-around',
        },
    },
    inputField: {
        '& .MuiInputBase-root': {
            color: theme.palette.text.primary,
        },
        '& .Mui-disabled': {
            cursor: 'not-allowed',
        },
        '& .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontSize: '1.5rem',
        },
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginBottom: theme.spacing(2),
            marginRight: 0,
        },
    },
});

export const KostnadsKalkyleModalTrigger: React.FC = () => {
    const classes = useKlpStyles({}, styles);
    const {
        toggleModal,
        isRequired,
        totalKostnadFormValue,
        fieldId,
        fieldLabel,
    } = useKostnadsKalkyleContext();

    const handleClick = () => {
        toggleModal();
    };
    return (
        <Box className={classes.container}>
            <NumericFormat
                className={classes.inputField}
                thousandSeparator={' '}
                decimalScale={2}
                decimalSeparator=","
                value={totalKostnadFormValue}
                customInput={TextField}
                variant="outlined"
                id={fieldId}
                label={fieldLabel}
                required={isRequired}
                disabled={true}
                size="small"
            />
            <ActionButton
                actionType="forward"
                translation="prosjekt.kostnadskalkyle.title.modalButton"
                onClick={handleClick}
            />
        </Box>
    );
};
